function validateListValues(values, key, rules) {
  var list = values[key];
  var results = {};
  list.forEach(function (item, itemIndex) {
    if (typeof item === "object" && item !== null) {
      Object.keys(item).forEach(function (listItemKey) {
        if (typeof rules[key][listItemKey] === "function") {
          var error = rules[key][listItemKey](item[listItemKey]);

          if (error) {
            results["".concat(key, ".").concat(itemIndex, ".").concat(listItemKey)] = error;
          }
        }
      });
    }
  });
  return results;
}

export { validateListValues };